import { request } from '../../shared/api/request'
import { audioFileName } from './voiceRecorder'

export const voiceApi = {
  transcribe: (blob: Blob) => { const data = new FormData(); data.append('file', blob, audioFileName(blob.type)); return request<{ text: string }>({ url: '/api/mini/speech/transcriptions', method: 'POST', data }) },
  synthesize: (conversationId: string, messageId: string) => request<Blob>({ url: `/api/mini/speech/synthesis?conversationId=${encodeURIComponent(conversationId)}&messageId=${encodeURIComponent(messageId)}`, responseType: 'blob' })
}

export type VoiceApi = typeof voiceApi
